import type { DischargeDayRow } from '../../shared/discharge';
export function dayStats(input:DischargeDayRow[]){
  const rows=[...input].sort((a,b)=>a.days-b.days),n=rows.reduce((s,r)=>s+r.episodes,0);
  const rank=(k:number)=>{let sum=0;for(const r of rows){sum+=r.episodes;if(sum>=k)return r.days;}return rows.at(-1)?.days??0;};
  const q=(p:number)=>{if(!n)return null;const h=(n-1)*p,lo=Math.floor(h),fraction=h-lo;return rank(lo+1)*(1-fraction)+rank(Math.ceil(h)+1)*fraction;};
  const p25=q(.25),p75=q(.75),iqr=(p75??0)-(p25??0);
  const inliers=rows.filter(r=>r.days>=(p25??0)-1.5*iqr&&r.days<=(p75??0)+1.5*iqr);
  return {lowerWhisker:inliers[0]?.days??null,upperWhisker:inliers.at(-1)?.days??null,outliers:rows.filter(r=>!inliers.includes(r)),n,mean:n?rows.reduce((s,r)=>s+r.days*r.episodes,0)/n:null,median:q(.5),p25:q(.25),p75:q(.75),p90:q(.9)};
}
export function dayBins(rows:DischargeDayRow[],width:number,maxDay:number,limit=maxDay){
  const regular=Math.ceil(Math.min(maxDay,limit)/width);
  const result=Array.from({length:regular},(_,i)=>({lo:i*width+1,hi:(i+1)*width,n:0,overflow:false}));
  if(maxDay>limit)result.push({lo:regular*width+1,hi:maxDay,n:0,overflow:true});
  for(const r of rows){const i=Math.min(result.length-1,Math.floor((r.days-1)/width));if(result[i])result[i].n+=r.episodes;}
  return result;
}
